<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">

        <el-form-item label="到期日期：">
          <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" style="width: 280px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="批次状态：">
          <el-select v-model="query.batch_type" clearable placeholder="请选择" style="width: 150px;">
            <el-option label="临期" value="1"></el-option>
            <el-option label="过期" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-input placeholder="请输入批次号/商品名称/商品编号" v-model="query.key" clearable style="width: 250px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="warning" icon="el-icon-search" @click="getList">查询</el-button>
          <el-button type="warning" icon="el-icon-download" @click="getexport">导出</el-button>
          <el-button type="warning" icon="el-icon-printer" @click="printBatch(multipleSelection)">批量打印</el-button>
        </el-form-item>

      </el-form>

      <div class="backborder2" style="margin-top:10px">
        <el-table :data="tableData" v-loading="listLoading" sortable="custom" @sort-change="sortTypeChange"
          @selection-change="handleSelectionChange">
          <!-- 多选框 -->
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="id" align="center" label="ID"></el-table-column>
          <el-table-column prop="batch_sn" align="center" label="批次号" width="170">
            <template slot-scope="scope">
              <!-- 正常 -->
              <div v-if="getType(scope.row) == 'normal'">{{ scope.row.batch_sn }}</div>

              <!-- 临期 -->
              <div v-if="getType(scope.row) == 'advent'" style="color: red;">{{ scope.row.batch_sn }}</div>
              <div v-if="getType(scope.row) == 'advent'" style="color: red;">【临期】</div>

              <!-- 过期 -->
              <div v-if="getType(scope.row) == 'expire'" style="color: red;">{{ scope.row.batch_sn }}</div>
              <div v-if="getType(scope.row) == 'expire'" style="color: red;">【过期】</div>
            </template>
          </el-table-column>
          <el-table-column prop="good_code" align="center" label="商品编码"></el-table-column>
          <el-table-column prop="good_name" align="center" label="商品名称" width="300"></el-table-column>
          <el-table-column prop="spec" align="center" label="商品规格"></el-table-column>
          <el-table-column prop="brand_name" align="center" label="品牌" width="150"></el-table-column>
          <el-table-column prop="warehouse_name" align="center" label="仓库" width="150"></el-table-column>
          <el-table-column prop="full_code" align="center" label="库位" width="150"></el-table-column>
          <el-table-column prop="unit" align="center" label="单位"></el-table-column>
          <el-table-column prop="numbers" align="center" label="库存"></el-table-column>
          <el-table-column prop="start_date" align="center" sortable label="生产日期" width="130">
            <template slot-scope="scope">
              {{ scope.row.start_date == '0' ? '/' : scope.row.start_date }}
            </template>
          </el-table-column>
          <el-table-column prop="realvalidity" align="center" label="有效期">
            <template slot-scope="scope">
              {{ scope.row.realvalidity }}{{ validityunitTemp[scope.row.validityunit] }}
            </template>
          </el-table-column>
          <el-table-column prop="end_date" align="center" sortable label="到期日期" width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.end_date != '0'" style="color: red;">
                {{ scope.row.end_date }}
              </span>
              <span v-if="scope.row.end_date == '0'">/</span>
            </template>
          </el-table-column>
          <el-table-column prop="early_warning_day" align="center" label="预警天数"></el-table-column>
          <el-table-column prop="remaining_days" align="center" sortable label="剩余天数" width="100">
            <template slot-scope="scope">
              <span style="color: red;">
                {{ scope.row.remaining_days }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="warning_date" align="center" sortable label="预警日期" width="130"></el-table-column>
          <el-table-column align="center" label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="scope.row.batch_sn && scope.row.batch_sn != '无批次'" type="text" size="mini"
                @click="printBatch([scope.row])">打印批次号</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange" :current-page="query.p"
            :page-sizes="[10, 20, 50]" :page-size="query.rollpage" layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
export default {
  props: ['childdata'],
  data() {
    return {
      transitionshow: true,
      url: this.GLOBAL.domain + "Inventory/index",
      query: {
        act: 'inventory_warning_list',
        date: [],
        start_date: '',
        end_date: '',
        rollpage: 10,
        p: 1,
        batch_type: '',
        key: '',
        sort_type: '',
        lift_type: ''
      },
      total_rows: 0,
      tableData: [],
      listLoading: false,
      validityunitTemp: {
        1: '日',
        2: '月',
        3: '年'
      },
      multipleSelection: []
    }
  },
  mounted() {
    if (this.childdata) {
      this.query.key = this.childdata.number
    }
    this.getList()
  },
  methods: {
    getType(row) {
      // end_date 到期日期
      // remaining_days 剩余天数
      // early_warning_day 预警天数
      const { end_date, remaining_days, early_warning_day } = row;

      // 如果没有到期日期，直接返回正常
      if (!end_date || end_date == '0') {
        return 'normal';
      }

      if (remaining_days < 0) {
        return 'expire'; // 过期
      } else if (remaining_days <= early_warning_day) {
        return 'advent'; // 临期
      } else {
        return 'normal'; // 正常
      }
    },
    sortTypeChange({ column, prop, order }) {
      // order：ascending = 上升
      // order：descending = 下降
      // prop = 字段名称
      // console.log(column, prop, order);

      this.query.p = 1
      let lift_type = ''
      if (order == 'ascending') {
        lift_type = 'asc'
      } else if (order == 'descending') {
        lift_type = 'desc'
      }
      this.query.sort_type = prop
      this.query.lift_type = lift_type
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /** 导出 - 直接下载的方法 **/
    getexport() {
      const data = JSON.parse(JSON.stringify(this.query))
      // 设置导出参数
      data.token = this.$cookies.get('token')
      if (data.date && data.date.length > 0) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }
      data.excel = 1
      data.p = 1

      const url = new URL(this.url);
      Object.keys(data).forEach(key => url.searchParams.append(key, data[key]));

      const link = document.createElement('a');
      link.href = url.toString();
      link.download = 'filename.xlsx'; // 设置下载文件的名称
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    },
    getList() {
      this.listLoading = true;
      const data = JSON.parse(JSON.stringify(this.query))
      if (data.date && data.date.length > 0) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }
      this.$axios({
        url: this.url,
        method: 'get',
        params: data
      }).then(res => {
        this.listLoading = false;
        if (res.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.tableData = res.Data
          console.log(res.Data)
          this.total_rows = parseInt(res.count);
        }
      })
        .catch(res => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading = false;
        });
    },
    printBatch(printList) {
      const list = printList.filter(item => item.batch_sn != '无批次')
      const pageContent = list.map(item => `
        <div class="print-page">
            <div class="label-row">
              <div class="label-column">商品名称：</div>
              <div class="value-column">${item.good_name}</div>
            </div>
            
            <div class="label-row">
              <div class="label-column">商品编码：</div>
              <div class="value-column">${item.good_code}</div>
            </div>

            <div class="label-row">
              <div class="label-column">批次号：</div>
              <div class="value-column">${item.batch_sn}</div>
            </div>

            <div class="label-row">
              <div class="label-column">有效期限：</div>
              <div class="value-column">${item.start_date != '0' && item.start_date ? item.start_date : '-'} 至 ${item.end_date != '0' && item.end_date ? item.end_date : '-'}</div>
            </div>
            

        </div>
      `).join('');

      const printHTML = `
        <!DOCTYPE html>
        <html>
            <head>
                <style>
                  @media print {
                      @page {
                          size: 130mm 76mm;
                          margin: 3mm 0 0 0;
                      }
                      
                      .print-page {
                          width: 128mm;        /* 总宽130mm - 2 * 1mm边距 */
                          height: 74mm;        /* 总高76mm - 2 * 1mm边距 */
                          padding: 1mm;        /* 内边距计入尺寸 */
                          box-sizing: border-box;
                          page-break-after: always; /* 强制分页[4](@ref) */
                          overflow: hidden;     /* 防止内容溢出[7](@ref) */
                          padding: 3mm 1mm 1mm 1mm;  /* 上边距3mm，其他边1mm */
                          margin-top: 0;             /* 覆盖默认外边距 */
                      }

                      .label-row {
                          display: flex;
                          margin-bottom: 6mm;
                          margin-left: 3mm;
                      }

                      .label-column {
                          width: 25mm;
                          font-size: 13pt;
                          line-height: 1.3;    /* 优化行高 */
                          white-space: nowrap;
                          word-break: keep-all;
                      }

                      .value-column {
                          width: calc(100% - 25mm - 2mm);
                          max-height: 70mm;     /* 预留4mm安全边距 */
                          font-size: 12pt;
                          line-height: 1.4;
                          word-break: break-word;
                          overflow-wrap: break-word;
                          box-sizing: border-box;
                          page-break-inside: avoid; /* 防止内容分页[8](@ref) */
                      }
                  }
                  </style>
            </head>
            <body onload="setTimeout(() => { window.print(); window.close() }, 500)">
                ${pageContent}
            </body>
        </html>
      `;

      const printWindow = window.open('', '_blank');
      printWindow.document.write(printHTML);
      printWindow.document.close();
    },
    pageSizeChange(val) {
      this.query.rollpage = val;
      this.getList();
    },
    pageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },
  }
}
</script>

<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}
</style>


// WEBPACK FOOTER //
// src/components/inventory/ShelfLifeWarning.vue